import Vue from "vue";

// Vue.use(require('vue-moment'));

import VueMoment from "vue-moment";
// import moment from "moment-timezone";

Vue.use(VueMoment, {
    // moment,
});
